import React, {FC} from 'react'
import {Routes, Route, useLocation} from "react-router-dom"
import {useSelector} from "react-redux"
import MetaTags from "react-meta-tags"
import getLocalizeString from "../../utils/getLocalizeString"
import Login from '../Login'
import Login2Auth from "../Login2Auth"
import Register from '../Register'
import Request from '../Request'
import Recover from '../Recover'
import Empty from '../Empty'
import Popup from "../Popup"
import css from './Auth.module.scss'

const Auth: FC = () => {
  const location = useLocation()
  const lang = useSelector(({reducer}: any) => reducer.lang)

  return (
    <div className={css.Auth}>
      <MetaTags>
        <meta property="og:title" content={`Surfe.be - ${getLocalizeString('Banner advertising placement service')}`}/>
        <meta property="og:url" content={`https://surfe.be${location.pathname}`}/>
        <meta property="og:image" content={`http://static.surfe.be/images/snippet/og_image_${lang}.jpg`}/>
      </MetaTags>

      <Routes>
        <Route path="/login" element={<Login/>}/>
        <Route path="/site/:authType" element={<Login2Auth/>}/>
        <Route path="/register" element={<Register/>}/>
        <Route path="/user/forgot" element={<Request/>}/>
        <Route path="/user/recover" element={<Recover/>}>
          <Route path=":uid/:token" element={<Recover/>}/>
        </Route>
        <Route path="*" element={<Empty/>}/>
      </Routes>
      <Popup/>
    </div>
  )
}

export default Auth
